import { render, staticRenderFns } from "./ApplicationFooter.vue?vue&type=template&id=083d3c5a&scoped=true"
import script from "./ApplicationFooter.vue?vue&type=script&lang=ts"
export * from "./ApplicationFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083d3c5a",
  null
  
)

export default component.exports